<div class="d-flex flex-column h-100 gap-3">
  <div class="d-flex flex-wrap align-items-end gap-3">
    <!-- <div class="d-flex flex-wrap align-items-center gap-3">
      <i class="bi bi-briefcase fs-28"></i>
      <h2 class="mb-0">Job Types</h2>
    </div> -->

    <!-- <div class="ms-auto"></div> -->
    <div class="d-flex align-items-center gap-3 ms-auto">
      <button class="btn btn-h42 btn-primary justify-content-center" (click)="onAddNew()">
        <i class="bi bi-briefcase fs-20"></i>
        Add Job Type
      </button>
    </div>
  </div>

  <div class="flex-fill overflow-hidden">
    <div class="table-outer table-theme">
      <div class="table-responsive h-100">
        <p-table
          [className]="'table-prime'"
          [value]="getData()"
          dataKey="id"
          [tableStyle]="{ 'min-width': '50rem' }"
          [scrollable]="true"
        >
          <ng-template #header>
            <tr>
              <th pSortableColumn="code">Code <p-sortIcon field="code" /></th>
              <th pSortableColumn="description">Description <p-sortIcon field="description" /></th>
              <th pSortableColumn="abbreviation">Abbreviation <p-sortIcon field="abbreviation" /></th>
              <!-- <th pSortableColumn="projectType">Project Type <p-sortIcon field="projectType" /></th> -->
              <th alignFrozen="right" pFrozenColumn [frozen]="true" class="bg-inherit"></th>
            </tr>
          </ng-template>
          <ng-template #body let-agency let-rowIndex="rowIndex">
            <tr>
              <td class="position-relative">
                <a class="stretched-link" [routerLink]="['../job-types', agency.id]" queryParamsHandling="preserve">{{
                  agency.code
                }}</a>
              </td>

              <td>{{ agency.description }}</td>
              <td>
                {{ agency.abbreviation }}
              </td>
              <!-- <td>{{ agency.projectType?.code }}</td> -->
              <td class="text-end align-baseline bg-inherit" alignFrozen="right" pFrozenColumn [frozen]="true">
                <div ngbDropdown container="body">
                  <svg-icon [name]="'menu-dots'" class="svg-24" ngbDropdownToggle></svg-icon>
                  <div ngbDropdownMenu>
                    <button ngbDropdownItem (click)="selectedJobId.set(agency.id); handleComponent()">Edit</button>

                    <button ngbDropdownItem (click)="onDeleteJobType(agency.id)">Delete</button>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<ng-template #confirmDeleteAgency let-modal>
  <div class="modal-body">
    <span class="text-center d-block">
      <svg-icon [name]="'confirm-icon'"></svg-icon>
    </span>
    <h1 class="fw-600 mt-4 mb-2 text-center">
      Delete
      @if (selectedJobId() !== null) {
        selected job types
      } @else {
        job type
      }
      ?
    </h1>
    <p class="h3 fw-400 mb-4 text-center">
      Are you sure you want to delete
      @if (selectedJobId() !== null) {
        these job types
      } @else {
        this job type
      }
      ? This action is permanent and cannot be undone.
    </p>

    <div class="d-flex justify-content-center gap-4">
      <button type="button" class="btn btn-shadow" (click)="modal.close('Save click'); selectedJobId.set(null)">
        Cancel
      </button>
      <!-- <button type="button" class="btn btn-danger" (click)="deleteJobType(selectedJobId()!); modal.close()">
        Delete
      </button> -->
    </div>
  </div>
</ng-template>
<router-outlet></router-outlet>
